import { Directive, ElementRef, Renderer2, inject } from '@angular/core';

@Directive()
export class FlexElementDirective {
  protected renderer2 = inject(Renderer2);
  protected nativeElement = inject(ElementRef).nativeElement;

  constructor() {}

  setStyle() {
    // this.renderer2.setStyle(this.nativeElement,, RendererStyleFlags2.DashCase)
  }
}
